import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcess101003Status: 'idle',
    startProcess101003Error: undefined as any,
    loadUserParamsProcess101003Status: 'idle',
    loadUserParamsProcess101003Error: undefined as any,

    process101003List: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcess101003 = createAsyncThunk('process101003Slice/startProcess101003', async ({ process101003 }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcess101003/`,
        prepareData(process101003),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcess101003Status } = getState().process101003Slice
        return startProcess101003Status !== 'pending'
    }
})

export const loadUserParamsProcess101003 = createAsyncThunk('process101003Slice/loadUserParamsProcess101003', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcess101003/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcess101003Status } = getState().process101003Slice
        return loadUserParamsProcess101003Status !== 'pending'
    }
})

const Process101003Slice = createSlice({
    name: 'process101003Slice',
    initialState,
    reducers: {
        resetstartProcess101003: (state) => {
            state.job = undefined
            state.startProcess101003Error = undefined
        },
        resetstartProcess101003Error: (state) => {
            state.startProcess101003Error = undefined
        },
        resetloadUserParamsProcess101003: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcess101003Error = undefined
        },
        resetloadUserParamsProcess101003Error: (state) => {
            state.loadUserParamsProcess101003Error = undefined
        },
        removeFromProcess101003ListById: (state, action) => {
            state.process101003List = state.process101003List.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcess101003ListByIds: (state, action) => {
            state.process101003List = state.process101003List.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.process101003List = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcess101003Status = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.process101003List = []
            state.startProcess101003Status = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcess101003.pending, (state) => {
            state.startProcess101003Status = 'pending'
            state.startProcess101003Error = undefined
        })
        builder.addCase(startProcess101003.fulfilled, (state, action) => {
            state.startProcess101003Status = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcess101003.rejected, (state, action) => {
            state.startProcess101003Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcess101003Error = action.error.message
            } else {
                state.startProcess101003Error = action.payload
            }
        })

        builder.addCase(loadUserParamsProcess101003.pending, (state) => {
            state.loadUserParamsProcess101003Status = 'pending'
            state.loadUserParamsProcess101003Error = undefined
        })
        builder.addCase(loadUserParamsProcess101003.fulfilled, (state, action) => {
            state.loadUserParamsProcess101003Status = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcess101003.rejected, (state, action) => {
            state.loadUserParamsProcess101003Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcess101003Error = action.error.message
            } else {
                state.loadUserParamsProcess101003Error = action.payload
            }
        })

    }
})

export const {
    resetstartProcess101003,
    resetstartProcess101003Error,
    resetloadUserParamsProcess101003,
    resetloadUserParamsProcess101003Error,
    removeFromProcess101003ListById,
    removeFromProcess101003ListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Process101003Slice.actions
export default Process101003Slice.reducer
